module.exports = __webpack_public_path__ + "media/images/logo/logo_chariloto-9c1528083be6d386f817829de50725a6.svg";